import lowerCase from 'lodash/lowerCase'
const files = require.context('.', false, /\.js$/)
const modules = {}

files.keys().forEach(fileName => {
  if (fileName === './index.js')
    return
  const moduleName= lowerCase(
    fileName.replace(/(\.\/|\.js)/g,'')
  )
  
  modules[moduleName.split(" ").join("_")] = files(fileName).default
});

export default modules